import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-[1040px]" }
const _hoisted_2 = { class: "flex items-center justify-between gap-6" }
const _hoisted_3 = {
  key: 0,
  class: "space-y-6 border-t border-gray-100 pt-5"
}
const _hoisted_4 = {
  key: 1,
  class: "text-sm text-gray-500"
}

import { computed, inject, onMounted, ref } from 'vue'

import ImageUploaderNeue from '@/components/neue/ImageUploaderNeue'
import InputArea from '@/components/neue/InputArea'
import NeueLoading from '@/components/neue/NeueLoading'
import NeueToggle from '@/components/neue/NeueToggle'
import SelectInput from '@/components/neue/SelectInput'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import api from '@/store/api'
import { mapRelationship, mapRelationships } from '@/store/mappers'


export default {
  __name: 'StoreSignup',
  props: ['id', 'only'],
  setup(__props) {

const bus = inject('bus')
const loading = ref(true)
const props = __props

// The page shows one of these two at a time, so it says which.
const shows = part => !props.only || props.only === part
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))
const automation = computed(() => mapRelationship(store.value?.relationships.new_signup_message_automation.data))
const template = computed(() => mapRelationship(automation.value?.relationships.message_template.data))

const modalText = ref('')
const automationEnabled = ref(false)
const message = ref('')
const attachmentType = ref('image')

const existingImages = computed(() =>
  mapRelationships(
    mapRelationship(automation.value?.relationships.message_template.data)?.relationships.attachments.data
  )
)

const load = () => {
  modalText.value = store.value.attributes.signup_modal_text
  automationEnabled.value = automation.value?.attributes.turned_on
  message.value = template.value?.attributes.body
  attachmentType.value = template.value?.attributes.attach_vcard ? 'vcard' : 'image'
}

onMounted(async () => {
  await api.call(
    'GET',
    `stores/${props.id}?included=new_signup_message_automation,new_signup_message_automation.message_template,new_signup_message_automation.message_template.attachments`
  )
  loading.value = false
  load()
})

const toggle = () => {
  api.call(
    'PUT',
    `stores/${props.id}?included=new_signup_message_automation,new_signup_message_automation.message_template,new_signup_message_automation.message_template.attachments`,
    {
      store: {
        new_signup_message_automation_attributes: { turned_on: automationEnabled.value }
      }
    }
  )
  message.value = ''
  attachmentType.value = 'image'
}

const changeImages = images => {
  api.call(
    'PUT',
    `stores/${props.id}?included=new_signup_message_automation,new_signup_message_automation.message_template,new_signup_message_automation.message_template.attachments`,
    {
      store: {
        new_signup_message_automation_attributes: {
          id: automation.value?.id,
          message_template_attributes: {
            id: template.value?.id,
            attach_vcard: attachmentType.value === 'vcard',
            attachments_attributes: images
          }
        }
      }
    }
  )
}

const dirty = () => bus.emit('dirty/store', { from: 'signup' })

bus.on('save/store', () => {
  api.call(
    'PUT',
    `stores/${props.id}?included=new_signup_message_automation,new_signup_message_automation.message_template,new_signup_message_automation.message_template.attachments`,
    {
      store: {
        signup_modal_text: modalText.value,
        new_signup_message_automation_attributes: {
          id: automation.value?.id,
          message_template_attributes: {
            id: template.value?.id,
            body: message.value,
            attach_vcard: attachmentType.value === 'vcard'
          }
        }
      }
    }
  )
})

bus.on('discard/store', load)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(NeueLoading), { loading: loading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (shows('explanation'))
          ? (_openBlock(), _createBlock(SettingsSection, {
              key: 0,
              title: "Sign-up message",
              description: "Shown below the phone number field on the sign-up page. Use it to explain what signing up gets a customer, or to promote a sign-up offer."
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(InputArea), {
                  modelValue: modalText.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((modalText).value = $event)),
                  placeholder: "Sign-up descriptions appear below the phone number field on the sign up page.",
                  onInput: dirty
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (shows('automation'))
          ? (_openBlock(), _createBlock(SettingsSection, {
              key: 1,
              title: "Automatic reply",
              description: "Sent to customers who sign up during checkout. It only reaches customers who have never had a sign-up message before and have never ordered."
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "min-w-0" }, [
                    _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Reply to new sign-ups"),
                    _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "Off means new sign-ups hear nothing from you.")
                  ], -1)),
                  _createVNode(_unref(NeueToggle), {
                    modelValue: automationEnabled.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((automationEnabled).value = $event)),
                    onChange: toggle
                  }, null, 8, ["modelValue"])
                ]),
                (automationEnabled.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_unref(InputArea), {
                        modelValue: message.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((message).value = $event)),
                        name: "Message",
                        placeholder: `Thanks for signing up to receive messages from ${store.value?.attributes?.store_name || 'us'}. To ensure you get all of our messages we suggest saving our number in your contacts.`,
                        onInput: dirty
                      }, null, 8, ["modelValue", "placeholder"]),
                      _createVNode(_unref(SelectInput), {
                        modelValue: attachmentType.value,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = $event => ((attachmentType).value = $event)),
                          dirty
                        ],
                        name: "Attachment",
                        options: [
              { name: 'Image', value: 'image' },
              { name: 'vCard (contact details)', value: 'vcard' }
            ]
                      }, null, 8, ["modelValue"]),
                      (attachmentType.value === 'image')
                        ? (_openBlock(), _createBlock(_unref(ImageUploaderNeue), {
                            key: 0,
                            files: existingImages.value,
                            editable: true,
                            "display-multiple": false,
                            "max-file-size": 2 * 1024 * 1024,
                            onChange: changeImages
                          }, null, 8, ["files"]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_4, "Your contact card will be automatically attached to this message."))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

}